'use es6';

import { extractScpPropertiesFromModule } from 'structured-content-lib/utils/transformers';
import { getImmutableOrPlain, isImmutable } from 'ContentEditorUI/utils/dataHelpers';
import { UPDATE_CURRENT_INSTANCE_VALUE, ADD_MODULES_TO_RICH_TEXT_PROPERTY } from 'structured-content-lib/redux/actions/ActionTypes';
import { selectTableAsModuleSchema } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { DefaultInstanceColumns } from 'structured-content-lib/constants/enums/DefaultInstanceColumns';
import { maybeToJS } from '../../utils/dataHelpers';
const getHasDataTokenPropertiesThatChanged = (scpDataTokens, changedProperties) => {
  return Boolean(changedProperties.some(changedProperty => scpDataTokens.indexOf(changedProperty) > -1));
};

// If the action is across iframes the metadata is a part of the payload
const getMetaDataFromAction = action => {
  return action.metaData || action.payload.metaData || {};
};
const getModulesWithStructuredContentChanges = ({
  allModules,
  scpPropertiesChanged,
  contentTypeAsModuleSchema,
  moduleMetadata
}) => {
  const modulesNeedingRefresh = [];
  const isModuleInRichTextUpdate = scpPropertiesChanged.includes(DefaultInstanceColumns.hs_modules_in_richtext);
  if (scpPropertiesChanged.includes('hs_name')) {
    // @TODO: Figure out scalable solution for inline properties so we don't hardcode them
    return modulesNeedingRefresh;
  }
  Object.values(allModules).forEach(currentModule => {
    var _currentModule$body;
    const moduleId = getImmutableOrPlain(currentModule, 'id');
    const isModuleInRichTextAffectedByChange = isModuleInRichTextUpdate && moduleMetadata && (
    // Module metadata will either be the module being edited
    // or `onAdd` the module's parent that it was added to
    getImmutableOrPlain(currentModule, 'parent_name') === moduleMetadata.id || moduleId === moduleMetadata.id);
    if (isModuleInRichTextAffectedByChange) {
      modulesNeedingRefresh.push(moduleId);
      return;
    }
    const moduleDataTokensMap = isImmutable(currentModule) ? currentModule.getIn(['body', 'data_tokens']) : currentModule === null || currentModule === void 0 || (_currentModule$body = currentModule.body) === null || _currentModule$body === void 0 ? void 0 : _currentModule$body.data_tokens;
    if (!moduleDataTokensMap) {
      return;
    }
    const scpDataTokens = extractScpPropertiesFromModule({
      data_tokens: maybeToJS(moduleDataTokensMap)
    }, contentTypeAsModuleSchema);
    if (scpDataTokens.includes('hs_body')) {
      return;
    }
    const hasDataTokenPropertiesThatChanged = getHasDataTokenPropertiesThatChanged(scpDataTokens, scpPropertiesChanged);
    if (hasDataTokenPropertiesThatChanged) {
      modulesNeedingRefresh.push(moduleId);
    }
  });
  return modulesNeedingRefresh;
};
export default function structuredContentModuleRefreshMiddleware() {
  return store => next => action => {
    if (action.type === UPDATE_CURRENT_INSTANCE_VALUE || action.type === ADD_MODULES_TO_RICH_TEXT_PROPERTY) {
      const {
        payload: {
          fieldKey: propertyName,
          newModuleInstances = []
        }
      } = action;
      const metadata = getMetaDataFromAction(action);
      const {
        moduleMetadata
      } = metadata;
      const state = store.getState();
      let allModules = getModules(state);
      const scpPropertiesChanged = [propertyName];
      if (action.type === ADD_MODULES_TO_RICH_TEXT_PROPERTY) {
        const newModules = newModuleInstances.reduce((acc, moduleInstance) => {
          acc[moduleInstance.name] = moduleInstance;
          return acc;
        }, {});
        scpPropertiesChanged.push(DefaultInstanceColumns.hs_modules_in_richtext);
        allModules = Object.assign({}, allModules, newModules);
      }
      const contentTypeAsModuleSchema = selectTableAsModuleSchema(state);
      const modulesNeedingRefresh = getModulesWithStructuredContentChanges({
        allModules,
        scpPropertiesChanged,
        contentTypeAsModuleSchema,
        moduleMetadata
      });
      if (modulesNeedingRefresh.length) {
        action.payload.moduleVersionsToUpdate = modulesNeedingRefresh;
      }
    }
    const result = next(action);
    return result;
  };
}